export const ChiselonOpeningsData = [
  {
    id: "JD-001",
    title: "Associate Talent Acquisition",
    department: "People & Talent",
    type: "Hybrid",
    location: "Coimbatore, India",
    experience: "1 - 3 Years",
    skills: [
      "Recruitment Coordination",
      "Sourcing experience- Naukri & Linkedin",
      "Screening & Shortlisting",
      "Interview Scheduling",
      "Communication Skills",
      "ATS Tools",
      
    ],
    description:
      "We are hiring an Associate Talent Acquisition professional to support end-to-end hiring functions including sourcing, screening, scheduling, and onboarding coordination. This role involves closely working with hiring managers and ensuring a seamless candidate experience."
  },

  {
    id: "JD-002",
    title: "Marketing Associate",
    department: "Marketing",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "2 - 4 Years",
    skills: [
      "Content Marketing",
      "Social Media Management",
      "Branding & Campaigns",
      "Market Research",
      "Copywriting",
      "Communication Skills",
      "Digital Marketing Tools"
    ],
    description:
      "We are looking for a Marketing Associate to support brand communication, campaign execution, and digital outreach initiatives. The ideal candidate will help manage marketing channels, build content, and contribute to brand visibility and engagement strategies."
  },

  {
    id: "JD-003",
    title: "Business Development Executive",
    department: "Sales & Growth",
    type: "Hybrid",
    location: "Hyderabad, India",
    experience: "2 - 5 Years",
    skills: [
      "Lead Generation",
      "Client Relationship Management",
      "Proposal Preparation",
      "Sales Presentations",
      "Outbound Communication",
      "Market Research",
      "Negotiation"
    ],
    description:
      "We are seeking a Business Development Executive to identify new business opportunities, build client relationships, and support sales pipeline growth. The role involves outreach, presentations, and coordination with internal teams to drive growth initiatives."
  }
];
